import { FunctionComponent } from 'preact';
import { useCallback } from 'preact/hooks';

import { usePlayerPip } from '../../hooks/usePlayerPip';
import { IconButton, IconButtonProps } from '../IconButton/IconButton';
import { useCast } from '../../hooks/CastProvider';
import { useTracker } from '../../hooks/useTracker';
import { useTpaasTracker } from '../../hooks/useTpaasTracker';
import { useIcons } from '../../hooks/useIcons';

const isPictureInPictureSupported = 'pictureInPictureEnabled' in document;

export const PipButton: FunctionComponent<IconButtonProps> = (props) => {
  const { trackEngagementUIElement } = useTpaasTracker();
  const { togglePip } = usePlayerPip();
  const { isActive } = useCast();
  const { trackButtonClick } = useTracker();
  const { PictureInPicture } = useIcons();

  const handlePip = useCallback(
    (e: MouseEvent) => {
      togglePip();
      trackButtonClick('pip');
      if (e.currentTarget instanceof Element) {
        trackEngagementUIElement({
          elementName: 'Toggle PictureInPicture',
          elementType: e.currentTarget.tagName.toLowerCase(),
          name: 'PictureInPicture',
        });
      }
    },
    [togglePip, trackButtonClick, trackEngagementUIElement]
  );

  if (isActive || !isPictureInPictureSupported) {
    return null;
  }

  return (
    <div className="vgp-pip-button">
      <IconButton onClick={handlePip} {...props}>
        <PictureInPicture />
      </IconButton>
    </div>
  );
};
